<div mat-dialog-title class="grid">
  <div class="column-title">
    <span>{{data.title}}</span>
  </div>
  <div class="column-close changecolorclose">
    <button mat-button (click)="closeDialog(false)">
      <mat-icon class="material-icons-outlined icon-close">close</mat-icon>
    </button>
  </div>
</div>
<div mat-dialog-content>
  <input type="file" class="file-input"
       [accept]="'image/x-png,image/gif,image/jpeg'"
       (change)="onFileSelected($event)" #fileUpload>

  <div class="file-upload" *ngIf="!uploadedImage?.imagePath">
    <div class="fake-input">Elegí el archivo a adjuntar</div>
    <button mat-button color="primary" class="upload-btn"
      (click)="fileUpload.click()">
        Seleccionar
    </button>
  </div>

  <div class="progress">
    <mat-progress-bar class="progress-bar" mode="determinate"
      [value]="uploadProgress" *ngIf="uploadProgress">
    </mat-progress-bar>
    <mat-icon class="material-icons-outlined cancel-upload" (click)="cancelUpload()" 
      *ngIf="uploadProgress">delete_forever</mat-icon>
  </div>

  <div class="image-preview" *ngIf="uploadedImage?.imagePath">
    <mat-icon class="material-icons-outlined">done</mat-icon> ¡La imagen se cargó satisfactoriamente!
  </div>

  <mat-form-field class="image-description" *ngIf="!data.hideDescription && uploadedImage">
    <input matInput type="text" [(ngModel)]="uploadedImageDescription"
      placeholder="Escribí una descripción para esta imagen"/>
  </mat-form-field>
</div>
<div mat-dialog-actions *ngIf="uploadedImage">
  <button mat-button (click)="closeDialog(false)" class="no-button">Cancelar</button>
  <button mat-button (click)="closeDialog(true)" cdkFocusInitial class="yes-button">Aceptar</button>
</div>